import React, { useRef, useState } from 'react';
import cx from 'classnames';
import './Card.css';
import Background from '../Background';

import { camelTitle } from '../../utils/camelTitle';

function Card({data, className, onDeepLink, onTrackState, onTrackAction, ...otherProps}) {
  const {title, image, imageLoading, detailLink, description, content, readMoreText, hideDetailText} = data;
  const rootRef = useRef();
  const [open, setOpen] = useState(false);
  const onDeepLinkClick = () => {
    onTrackAction && onTrackAction('OpenNews_Pic', JSON.stringify({'link.category': 'HarmonyLanding', assetid: camelTitle(title)}))
    onDeepLink && detailLink && onDeepLink(detailLink);
  };
  const expand = () => {
    !open && onTrackAction && onTrackAction('OpenNews_Link', JSON.stringify({'link.category': 'HarmonyLanding', assetid: camelTitle(title)}));
    setOpen(!open);
  };
  return (
    <div ref={rootRef} className={cx('ha-card-root', className)} {...otherProps}>
      <div className={cx('ha-card-real')}>
        <Background className='head-image' onClick={onDeepLinkClick} src={image} placeholder={imageLoading}/>
        <div className='card-content'>
          <h4>{title}</h4>
          {(!open || !content) && <p>{description}</p>}
          {open && content && <div className='raw-html-contents' dangerouslySetInnerHTML={{ __html: (content || '').replace(/\n/g, '<br />')}} />}
          {content && <div className='readmore' onClick={expand}>
            {open ? hideDetailText : readMoreText}
          </div>}
        </div>
      </div>
    </div>

  )
}
export default Card;
